import React from "react";
import { cn } from "utils";
import Translations from "@translate/components/Home/MarketIndicators/FearGreedGauge/FearGreedGaugeH5";
import { I18nUtil } from "@utils/i18n";
import { GaugeDial } from "@/src/components/GaugeDial";

const I18n = I18nUtil.createScoped(Translations);

interface FearGreedGaugeH5Props {
  /** 当前值 (0-100) */
  value: number;
  /** 标题 */
  title?: string;
  /** 自定义类名 */
  className?: string;
  /** 标题自定义类名 */
  titleClassName?: string;
  /** 仪表盘宽度（支持数字、百分比、calc等CSS值） */
  width?: number | string;
}

/**
 * Fear & Greed Index 仪表盘组件
 * 显示一个半圆形的仪表盘，带有渐变色圆弧
 */
export const FearGreedGaugeH5: React.FC<FearGreedGaugeH5Props> = ({
  value,
  title = I18n.t("Fear & Greed Index"),
  className,
  titleClassName,
  width: propWidth,
}) => {
  // 确保值在 0-100 范围内
  const normalizedValue = Math.max(0, Math.min(100, value));

  // 根据值判断状态
  const getStatus = (val: number) => {
    if (val < 25) {
      return I18n.t("Extreme Fear");
    }
    if (val < 50) {
      return I18n.t("Fear");
    }
    if (val < 55) {
      return I18n.t("Neutral");
    }
    if (val < 75) {
      return I18n.t("Greed");
    }
    if (val < 100) {
      return I18n.t("Extreme Greed");
    }
    return I18n.t("Extreme Greed");
  };

  const status = getStatus(normalizedValue);

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {/* 标题 */}
      <h3
        aria-label="Fear Greed Gauge H5 h3"
        data-openreplay-label="Fear Greed Gauge H5 h3 Semantic"
        id="sem-fear-greed-gauge-h5-h3"
        className={cn("body_medium_s text-content_tertiary", titleClassName)}
      >
        {title}
      </h3>

      <div className="flex items-center justify-center">
        {/* 右侧仪表盘 */}
        <GaugeDial
          value={normalizedValue}
          status={status}
          width={propWidth}
          showValue={true}
        />
      </div>
    </div>
  );
};
